module.exports = __webpack_public_path__ + "img/template-management-copy.411416d8.svg";